export default "__VITE_PUBLIC_ASSET__31f47f13__"